function Button({
  innerText,
  icon,
  innerClass,
  iconClass,
  outerClass,
  onClick,
  suffixIcon,
  outerStyle,
  iconType,
}) {
  const Icon = icon;
  const SuffixIcon = suffixIcon;

  return (
    <button
      style={outerStyle}
      onClick={onClick}
      className={`flex gap-2 ${outerClass}`}
    >
      {icon && iconType !== "svg" && (
        <img src={icon} alt="" className={`${iconClass}`} />
      )}
      {icon && iconType === "svg" && <Icon className={`${iconClass}`} />}
      {innerText && (
        <span className={`${innerClass} transition-all duration-600`}>
          {innerText}
        </span>
      )}
      {suffixIcon && iconType !== "svg" && (
        <img src={suffixIcon} alt="" className={`${iconClass}`} />
      )}
      {suffixIcon && iconType === "svg" && (
        <SuffixIcon className={`${iconClass}`} />
      )}
    </button>
  );
}

export default Button;
